module.exports = __webpack_public_path__ + "static/contribution_img5_on@2x-072ad41f9900a854f6dec011df2fc99a.jpg";